export enum ChangeWorkspaceModalStatus {
  CREATE_BLANK,
  CREATE_FROM_TEMPLATE,
  OPEN,
}
